import { useTranslation } from "react-i18next";
import {
  getFiscalCodePattern,
  getTranslatedLabel,
} from "../../../utils/helpers";

const FiscalCodeInputFieldRHF = (props: any) => {
  const { t } = useTranslation();

  const { register, formField, errors, setValue } = props;
  const label = getTranslatedLabel(formField.translations);

  /**
   * css variable.
   */
  const styles = errors[formField.name] ? "border border-danger" : "";

  /**
   * Error messsages variables.
   */
  const minLengthErrors = {
    value: 16,
    message: t("required.invalid-fiscal-code"),
  };
  const maxLengthErrors = {
    value: 16,
    message: t("required.invalid-fiscal-code-length"),
  };

  return (
    <>
      <input
        {...register(formField.name, {
          required: formField.required,
          minLength: { ...minLengthErrors },
          maxLength: { ...maxLengthErrors },
          pattern: {
            value: getFiscalCodePattern(),
            message: t("required.invalid-fiscal-code"),
          },
        })}
        onChange={(e: any) =>
          setValue(formField.name, e.target.value.toUpperCase(), {
            shouldValidate: e.target.value.length >= 16 ? true : false,
          })
        }
        onBlur={(e: any) =>
          setValue(formField.name, e.target.value.toUpperCase(), {
            shouldValidate: true,
          })
        }
        type={formField.type}
        name={formField.name}
        className={`form-control Input ${styles}`}
      />

      {errors[formField.name] && (
        <div className="validation-errors-text-size text-danger mt-1 ms-2">
          {errors[formField.name]?.message
            ? errors[formField.name].message
            : t("dynamic-form.required", { param: label })}
        </div>
      )}
    </>
  );
};

export default FiscalCodeInputFieldRHF;
